// Botão com link no produto do Google: site, página ou WhatsApp do cliente.
// O operador não tinha onde informar esse link (Reinaldo, 14/09/2026).

export const BOTOES_DO_PRODUTO = [
  { valor: "SAIBA_MAIS", rotulo: "Saiba mais" },
  { valor: "COMPRAR", rotulo: "Comprar" },
  { valor: "PEDIR_ONLINE", rotulo: "Pedir on-line" },
  { valor: "VER_OFERTA", rotulo: "Ver oferta" },
] as const;

/**
 * Link de site pronto para o Google, ou null. Quem digita só o endereço
 * ("www.site.com.br") ganha o https://; o que não é http/https é recusado.
 */
export const normalizarLink = (texto?: string | null): string | null => {
  const valor = (texto ?? "").trim();
  if (!valor || /\s/.test(valor)) return null;
  const temEsquema = /^[a-z][a-z0-9+.-]*:/i.test(valor);
  const candidato = temEsquema ? valor : `https://${valor}`;
  try {
    const url = new URL(candidato);
    if (url.protocol !== "http:" && url.protocol !== "https:") return null;
    if (!url.hostname.includes(".")) return null;
    return candidato;
  } catch {
    return null;
  }
};

/** wa.me do número do perfil, com o 55 quando falta; null se não dá para chamar. */
export const linkDoWhatsApp = (numero?: string | null): string | null => {
  let digitos = (numero ?? "").replace(/\D/g, "");
  if (digitos.length === 10 || digitos.length === 11) digitos = `55${digitos}`;
  if (!digitos.startsWith("55") || digitos.length < 12 || digitos.length > 13) {
    return null;
  }
  return `https://wa.me/${digitos}`;
};

/** Campo preenchido que não vira link trava o envio; vazio pode (o link é opcional). */
export const linkInvalido = (texto?: string | null): boolean =>
  !!(texto ?? "").trim() && normalizarLink(texto) === null;
